import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { useLang } from "../../i18n/LanguageContext";

export default function FAQ() {
  const { t } = useLang();
  return (
    <section className="relative py-24 md:py-32 bg-[var(--aa-cream)]">
      <div className="mx-auto max-w-4xl px-6 md:px-8">
        <div className="reveal text-center">
          <div className="text-[11px] tracking-[0.24em] uppercase text-[var(--aa-wine)] font-semibold mb-4">
            {t.faq.eyebrow}
          </div>
          <h2 className="font-display font-light text-4xl md:text-6xl leading-[1.05] text-[var(--aa-ink)]">
            {t.faq.h2a} <span className="italic">{t.faq.h2b}</span>
          </h2>
        </div>

        <div className="reveal mt-12">
          <Accordion type="single" collapsible className="space-y-3">
            {t.faq.items.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="rounded-2xl border border-[var(--aa-line)] bg-white px-5 md:px-6 data-[state=open]:shadow-sm"
              >
                <AccordionTrigger className="text-left font-display text-lg md:text-xl text-[var(--aa-ink)] hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[14.5px] text-[var(--aa-ink-soft)] leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
